import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../store/store.ts';
import { DoraRisk } from '../../models/doraRisk.ts';

interface DoraRiskState {
  doraRisks: DoraRisk[];
  selectedDoraRisk: DoraRisk | null;
}

const initialState: DoraRiskState = {
  doraRisks: [],
  selectedDoraRisk: null,
};

const doraRiskSlice = createSlice({
  name: 'doraRisk',
  initialState,
  reducers: {
    setDoraRisks(state, action: PayloadAction<DoraRisk[]>) {
      state.doraRisks = action.payload;
    },
    addDoraRisk(state, action: PayloadAction<DoraRisk>) {
      state.doraRisks.push(action.payload);
    },
    updateDoraRisk(state, action: PayloadAction<DoraRisk>) {
      const index = state.doraRisks.findIndex(risk => risk.id === action.payload.id);
      if (index !== -1) state.doraRisks[index] = action.payload;
    },
    removeDoraRisk(state, action: PayloadAction<number>) {
      state.doraRisks = state.doraRisks.filter(risk => risk.id !== action.payload);
    },
    setSelectedDoraRisk(state, action: PayloadAction<DoraRisk | null>) {
      state.selectedDoraRisk = action.payload;
    },
  },
});

export const {
  setDoraRisks,
  addDoraRisk,
  updateDoraRisk,
  removeDoraRisk,
  setSelectedDoraRisk,
} = doraRiskSlice.actions;

export const selectDoraRisks = (state: RootState) => state.doraRisk.doraRisks;
export const selectSelectedDoraRisk = (state: RootState) => state.doraRisk.selectedDoraRisk;

export default doraRiskSlice.reducer;
